/**
 * The sidebar's tree, as words. The structure stays in `components/navigation.ts` with the
 * routes and icons; only labels and descriptions live here, keyed by the router's own path.
 */
export const navigatie = {
  overzicht: {
    label: "Overzicht",
    omschrijving:
      "Beheren van alles wat de wedstrijdleiders regelen, met wat er nog te doen is.",
  },

  groepen: {
    inschrijvingen: "Inschrijvingen",
    seizoen: "Seizoen",
    beheer: "Beheer",
  },

  paginas: {
    ploegen: {
      label: "Ploegen",
      omschrijving:
        "Beheren van de ingeschreven ploegen en hun voorkeursdatums, namens het korps.",
    },
    ondersteuners: {
      label: "Ondersteuners",
      omschrijving:
        "Beheren van de beschikbaarheid die ondersteuners hebben doorgegeven, namens die persoon.",
    },
    seizoenen: {
      label: "Seizoenen",
      omschrijving: "Beheren van de wedstrijdseizoenen.",
    },
    wedstrijddagen: {
      label: "Wedstrijddagen",
      omschrijving:
        "Beheren van de wedstrijddagen, met hun niveau, organiserend korps en banen.",
    },
    inschrijfperiodes: {
      label: "Inschrijfperiodes",
      omschrijving:
        "Beheren van de inschrijfperiodes en de aankondiging aan de doelgroep.",
    },
    reistijden: {
      label: "Reistijden",
      /** Names both, or nobody looks here for an ondersteuner (ADR-0053). */
      omschrijving:
        "Beheren van de reistijden van korpsen en ondersteuners naar de wedstrijddagen.",
    },
    reistijdenKorpsen: { label: "Korpsen" },
    reistijdenOndersteuners: { label: "Ondersteuners" },
    planning: {
      label: "Planning",
      omschrijving:
        "Beheren van de planning van ploegen en ondersteuners op de banen.",
    },
    wedstrijdboekjes: {
      label: "Wedstrijdboekjes",
      omschrijving:
        "Beheren van de wedstrijdboekjes van dit seizoen en hun versies.",
    },
    wedstrijdboekjesSjabloon: { label: "Sjabloon" },
    stamgegevens: {
      label: "Stamgegevens",
      omschrijving:
        "Beheren van de functies, klassen, niveaus, speelschema's en standaardteksten voor alle seizoenen.",
    },
    functies: { label: "Functies" },
    klassen: { label: "Klassen" },
    niveaus: { label: "Niveaus" },
    speelschemas: { label: "Speelschema's" },
    standaardteksten: { label: "Standaardteksten" },
    bevoegdheden: {
      label: "Bevoegdheden",
      omschrijving:
        "Beheren van de functies die een ondersteuner mag vervullen.",
    },
    lokaleAccounts: {
      label: "Accounts",
      omschrijving:
        "Beheren van de accounts waarmee iemand kan inloggen.",
    },
    synchronisaties: {
      label: "Synchronisaties",
      omschrijving:
        "Beheren van de synchronisaties met het JBNL Portaal en VBS.",
    },
    handleiding: { label: "Handleiding" },
  },

  /** The chevron beside a section that has pages folded under it. */
  submenu: {
    open: "{{sectie}} openklappen",
    dicht: "{{sectie}} dichtklappen",
  },
} as const;
